// extracted by mini-css-extract-plugin
export var activityContainer = "_nj-0";
export var typingIndicatorContainer = "_nj-1";
export var typingIndicatorDot = "_nj-2";
export var wave = "_nj-3";